module.exports = __webpack_public_path__ + "img/MiniRicardo.e9fabf64.png";